import API from "./api";
import type { CreerDemandeVerificationPayload, DemandeVerificationAttachmentDto } from "@/types/demande-verification.types";

const DemandeVerificationService = {
  creer: async (payload: CreerDemandeVerificationPayload) => {
    const response = await API.post("/demandes-verification", payload);
    return response.data.donnees;
  },

  uploadPieceJointe: async (file: File): Promise<DemandeVerificationAttachmentDto> => {
    const formData = new FormData();
    formData.append("file", file);
    const response = await API.post("/demandes-verification/pieces-jointes", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data.donnees;
  },

  getAll: async () => {
    const response = await API.get("/demandes-verification");
    return response.data.donnees;
  },

  marquerLue: async (id: number) => {
    const response = await API.post(`/demandes-verification/${id}/lu`);
    return response.data.donnees;
  },

  delete: async (id: number) => {
    const response = await API.delete(`/demandes-verification/${id}`);
    return response.data.donnees;
  },
};

export default DemandeVerificationService;
